<div class="container" class="footer-class">
  <div class="row">
    <div class="col-sm">
      <div class="inline-content">
        <img
          src="assets/images/icons/notify.svg"
          class="notify-icon"
          alt="notification-icon"
        />
        <span class="context-text">
          As soon as you make some edits, please make sure that you saved this
          to reflect in projects
        </span>
      </div>
    </div>
  </div>
</div>
